import { TableCell, TableRow, useTheme } from "@mui/material"
import { updateAssetRegister } from "routes/asset-register/controller/update-asset-register"
import { confirm } from "lib/@dialogs/confirm"
import { noChange, useRefresh } from "lib/@hooks/useRefresh"
import { BlockClicks } from "lib/@components/block-clicks"
import { Secure } from "lib/authorization/secure"
import { busyWhile } from "lib/@components/busy/busy-while"
import { Feature } from "lib/@components/feature"
import { Repeat } from "lib/@components/repeat"
import { ContextMenuBar } from "lib/@components/context-menu-bar"
import { ContextMenuItem } from "lib/@components/context-menu-bar/context-menu-item"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { useMemo } from "react"
import { formatDatesInAssetOrTask } from "routes/asset-register/plugins/regime-display/format-dates-in-asset-or-task"
import { DATE_FORMATS } from "lib/@constants/date-format"
import { stickyActionCellSx } from "routes/asset-register/plugins/regime-display/asset-view-table/asset-view-pinned-cell-styles"
import { AssetRegisterBodyCell } from "./asset-register-body-cell"

export function AssetRegisterEntry({ item, register, canEdit = true }) {
    const refresh = useRefresh(noChange)
    const { resolvedColumns } = useBoundContext()
    const theme = useTheme()

    useMemo(applyDateFormats, [item])

    return (
        item && (
            <TableRow data-cy="asset-entry-row">
                <Repeat keyFn={keyByField} list={resolvedColumns ?? []} item={<AssetRegisterBodyCell asset={item} />} />
                <TableCell sx={{ width: "100%", p: 0 }} />
                <Feature feature="edit-assets">
                    {canEdit && (
                        <TableCell sx={stickyActionCellSx(theme)}>
                            <BlockClicks>
                                <Secure demand="manageRegime">
                                    <ContextMenuBar
                                        type="asset-register-row"
                                        label={`More actions for ${item.tag || "this asset"}`}
                                    >
                                        <ContextMenuItem
                                            icon="mdi:delete"
                                            label={`Delete ${item.type || "Asset"}`}
                                            onClick={removeAsset}
                                            data-cy="remove-asset-btn"
                                        />
                                    </ContextMenuBar>
                                </Secure>
                            </BlockClicks>
                        </TableCell>
                    )}
                </Feature>
            </TableRow>
        )
    )

    async function removeAsset() {
        if (
            await confirm(
                "Are you sure you want to permanently remove this asset from the register?",
                "Irreversible Action"
            )
        ) {
            await busyWhile(
                async () => updateAssetRegister({ registerId: register, removeAssets: [item.id] }),
                "Removing Asset"
            )
            refresh()
        }
    }

    function applyDateFormats() {
        try {
            formatDatesInAssetOrTask(item, DATE_FORMATS.medium)
        } catch (e) {
            console.error("asset-register-entry: invalid date in item", item?.id, e)
        }
    }

    function keyByField(column) {
        return column.field
    }
}
